/**
 * Keeps the cart drawer's free-shipping progress bar in sync with the cart.
 *
 * The theme refreshes the progress *message* on every cart change (it is listed
 * in cartSectionsList in cart.js) but only re-animates the <progress> element on
 * some update paths. After a quantity change the bar can therefore sit at a
 * stale fill while the text above it already reads correctly. This re-reads the
 * live cart after each cart mutation and sets the bar - and the milestone icon -
 * to match.
 */
(function () {
  function thresholdFor(bar, progress) {
    var max = parseInt(bar.getAttribute('data-free-shipping-price'), 10);
    if (!max || max <= 0) max = parseInt(progress.getAttribute('max'), 10);
    return max > 0 ? max : 0;
  }

  function sync() {
    var bar = document.querySelector('.free-product-progress-bar');
    var progress = bar && bar.querySelector('progress');
    if (!bar || !progress) return;

    var max = thresholdFor(bar, progress);
    if (!max) return;

    // /cart.js is not a cart mutation, so this never re-triggers the wrapper below.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var total = cart.total_price || 0;
        var current = document.querySelector('.free-product-progress-bar progress');
        if (!current) return;

        current.setAttribute('max', max);
        current.value = Math.min(total, max);

        var icon = document.querySelector('.free-shipping-main');
        if (icon) {
          if (total >= max) icon.classList.add('free-shipping-main-color');
          else icon.classList.remove('free-shipping-main-color');
        }
      })
      .catch(function () {});
  }

  // Two passes: one soon after the cart responds, one after the theme's own
  // progress animation (1s) has finished, so whichever runs last is correct.
  var earlyTimer = null;
  var lateTimer = null;
  function queueSync() {
    clearTimeout(earlyTimer);
    clearTimeout(lateTimer);
    earlyTimer = setTimeout(sync, 500);
    lateTimer = setTimeout(sync, 1600);
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch.apply(this, arguments);

    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
      promise
        .then(function (response) {
          if (response && response.ok) queueSync();
        })
        .catch(function () {});
    }

    return promise;
  };

  document.addEventListener('cart-drawer:update', queueSync);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueSync);
  } else {
    queueSync();
  }
})();
